export default __webpack_public_path__ + "static/media/mml_logo_bluelines.9d6055fb.png";